import { CSSProperties } from "react";

/**
 * The ✕ of a closeable pill (location pills, Typeahead chips). It has to stay an
 * `<a>` because the icon is a background image bound to the `.folder--closeable a`
 * and `.filterpill--closeable a` selectors, and it has no `href` because it
 * doesn't navigate — so the button semantics, the keyboard activation and the
 * label all have to be supplied here.
 */
export function RemoveFilterButton(props: { label: string; onRemove(): void; style?: CSSProperties }) {
  const { label, onRemove, style } = props;
  return (
    <a
      role="button"
      tabIndex={0}
      aria-label={`Remove ${label} filter`}
      className="cursor--pointer"
      style={style}
      onClick={onRemove}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onRemove();
        }
      }}
    />
  );
}
